import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/apps/home-webapp/src/app/(pages)/insurance/_components/Tabs/index.tsx");
